import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../domain';
import {X9ContentViewStore} from '../../common/X9ContentViewStore';
import {StudentSyncedVideo} from '../classroom/student/StudentSyncedVideo';
import {TeacherSyncedVideo} from '../classroom/teacher/TeacherSyncedVideo';

interface Props {
  x9: X9Content | X9ContentSnapshot;
}

@observer
export class X9SyncedVideoView extends React.Component<Props> {
  readonly store: X9ContentViewStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new X9ContentViewStore(props.x9);
  }

  render() {
    const store = this.store;
    const x9 = this.props.x9;
    return (
      <div className="row videoPreview">
        <div className="col-6">
          <TeacherSyncedVideo x9={x9} store={store}/>
        </div>
        <div className="col-6">
          <StudentSyncedVideo x9={x9} store={store}/>
        </div>
      </div>);
  }
}
